import React from 'react';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import JoiningExpenses from './joiningExpenses/JoiningExpenses';

import '../Landing.css';
import { Grid, List, ListItem, ListItemText, Card, CardContent } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import headersSection from '../headersStyle';
import Steps from '../../../../assets/icons/ReactSvg/Steps';

import nakaz from '../../../../assets/images/landing/Nakaz/nakaz79.pdf';

// import JoiningExpenses from './joiningExpenses/JoiningExpenses';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // paddingLeft: '100px'
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    height: 240,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  title: {
    fontSize: '18px',
    textAlign: 'center',
    margin: 0,
    padding: '10px 0',
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  // ...testimonialsSection,
  pageHeader: {
    position: 'relative',
    height: '100vh',
    maxHeight: '1600px',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb('#000') + ', 0.5)',
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''",
    },
  },
  regulationLink: {
    display: 'block',
    marginBottom: '30px',
  },
  icon: {
    float: 'none',
    // marginTop: "30px",
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '61px',
    height: '61px',
    // marginBottom: "24px",
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) rotate(90deg)',
  },
  composition: {
    marginTop: '40px',
    marginBottom: '34px',
    position: 'relative',
    height: '62px',
  },
  horizontalLine: {
    borderTop: '1px solid #283e70',
    width: '100%',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '0',
  },
  dot: {
    width: '4px',
    height: '4px',
    border: '1px solid #283e70',
    backgroundColor: '#283e70',
    overflow: 'hidden',
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  positionOne: { left: '0' },
  positionTwo: { left: '50%' },
  positionThree: { left: '100%' },
  highlighted: { fontWeight: 'bold' },
}));

const Connecting = (props) => {
  const { classes } = props;
  const expClasses = useStyles();
  return (
    //    {/* CONNECTING */}
    <div className={classes.person} id="connecting">
      <div className={classes.container}>
        <Grid container justify="center">
          <Grid item xs={12} sm={12} md={10} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <h2 className={classes.title}>
              Підключитись до програмного комплексу «Інтегрована інформаційна система «Соціальна громада» у 2 кроки!
            </h2>
            <a className="font-weight-bold text-center title" href={nakaz} download>
              <span style={{ display: 'block', marginBottom: '10px' }}>
                Наказ Міністерства соціальної політики України <br />
                “Про упровадження програмного комплексу “Інтегрована інформаційна система “Соціальна громада” <br />№ 79
                від 12 лютого 2021 року
              </span>
            </a>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={10}>
            <div className={expClasses.root}>
              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  Вартість технічного та інформаційно-консультаційного супроводу Програмного комплексу «Інтегрована
                  інформаційна система «Соціальна громада»
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <JoiningExpenses />
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </Grid> */}

          <Grid item xs={12} sm={12} md={10}>
            <Card className={classes.card}>
              <CardContent>
                З 01.01.2021 року вартість технічного та інформаційно-консультаційного супроводу програмного комплексу
                «Інтегрована інформаційна система «Соціальна громада» (ПК «ІІС «Соціальна громада») фінансується за
                рахунок Міністерства соціальної політики України
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={12} md={10}>
            <div className={expClasses.root}>
              <Grid container justify="center">
                <Grid item xs={4}>
                  <div className={expClasses.composition}>
                    <div className={`${expClasses.icon} ${expClasses.positionOne}`}>
                      <Steps />
                    </div>
                    {/* <div className={`${expClasses.dot} ${expClasses.positionTwo}`}></div> */}
                    <div className={`${expClasses.dot} ${expClasses.positionThree}`}></div>
                    <div className={expClasses.horizontalLine}></div>
                  </div>
                </Grid>
              </Grid>

              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={expClasses.headingNormal}>
                    1. <b>Самостійно перевірити</b> відповідність комп’ютера (комп’ютерів) та швидкість мережі інтернет
                    мінімальним технічним вимогам
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div>
                    <p className="font-weight-bold" style={{ textAlign: 'right' }}>
                      Додаток 2<br />
                      до листа Мінсоцполітики
                    </p>

                    <h4 className="ml-4 text-center font-weight-bold title">
                      Мінімальні технічні вимоги
                      <br />
                      до робочого місця та до швидкості мережі інтернет
                    </h4>

                    <h5 className="ml-4 text-center font-weight-bold title">Браузер:</h5>

                    <List>
                      <ListItem>
                        <ListItemText primary="Google Chrome, версія: 71+;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Mozilla FireFox, версія: 64+." />
                      </ListItem>
                    </List>

                    <h3 className="ml-4 text-center font-weight-bold title">
                      Операційні системи, які мають офіційну підтримку та здатні працювати з шифруванням:
                    </h3>

                    <h5 className="ml-4 text-center font-weight-bold title">Microsoft Windows 7:</h5>
                    <List>
                      <ListItem>
                        <ListItemText primary="Процесор: 1 ГГц 32-розрядна (x86) або 64-розрядна (x64);" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Оперативна пам”ять:1 гігабайт (ГБ) (для 32-розрядної системи) або 2 ГБ (для 64- розрядної системи;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="16 гігабайт (ГБ) (для 32- розрядної системи) або 20 ГБ (для 64- розрядної системи) на жорсткому диску;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Графічний адаптер: DirectX 9 с драйвером WDDM версії 1.0 або вище." />
                      </ListItem>
                    </List>

                    <h5 className="ml-4 text-center font-weight-bold title">Microsoft Windows 8.1, 10:</h5>

                    <List>
                      <ListItem>
                        <ListItemText primary="Процесор: 1 ГГц або вище з підтримкою функцій PAE, NX і SSE2;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Оперативна пам'ять: 1 ГБ (для 32-розрядної системи) або 2 ГБ (для 64-розрядної системи);" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Вільне місце на жорсткому диску: 16 ГБ (для 32- розрядної системи) або 20 ГБ (для 64- розрядної системи);" />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary="Графічний адаптер: DirectX 9 с драйвером WDDM версії 1.0 або вище.
                  Microsoft Windows 10;"
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Процесор: 1 ГГц або вище з підтримкою функцій PAE, NX і SSE2;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Оперативна пам”ять: 1 ГБ (для 32-розрядної системи) або 2 ГБ (для 64-розрядної системи);" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Вільне місце на жорсткому диску: 16 ГБ (для 32- розрядної системи) або 20 ГБ (для 64- розрядної системи);" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Графічний адаптер: DirectX 9 с драйвером WDDM версії 1.0 або вище." />
                      </ListItem>
                    </List>

                    <h5 className="ml-4 text-center font-weight-bold title">Вимоги до мережі Інтернет:</h5>
                    <List>
                      <ListItem>
                        <ListItemText primary="Смуга пропускання для 1 модуля шифрування  5 Мбіт/с;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Затримка в одному напрямку  10 мс;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Повна затримка  20 мс;" />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="Втрата пакетів за визначений період часу 1%" />
                      </ListItem>
                    </List>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
            {/* <img src={paw} alt="paw" width="50" style={{ margin: '30px 0' }}></img> */}
          </Grid>
          <Grid item xs={12} sm={12} md={10}>
            <div className={expClasses.root}>
              <Grid container justify="center">
                <Grid item xs={4}>
                  <div className={expClasses.composition}>
                    <div className={`${expClasses.icon} ${expClasses.positionThree}`}>
                      <Steps />
                    </div>
                    <div className={`${expClasses.dot} ${expClasses.positionOne}`}></div>
                    {/* <div className={`${expClasses.dot} ${expClasses.positionThree}`}></div> */}
                    <div className={expClasses.horizontalLine}></div>
                  </div>
                </Grid>
              </Grid>

              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={expClasses.headingNormal}>
                    2.{' '}
                    <b>
                      <a href="/register">Заповнити електронну заявку</a>
                    </b>{' '}
                    на отримання модуля(ів) шифрування. Заявка подається сільським, селищним, міським головою.
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div>
                    <p>Отримати на вказану при поданні Заявки офіційну пошту ТГ:</p>
                    <h5 className="ml-4">Інструкції щодо налаштування:</h5>
                    <List>
                      <ListItem>
                        <ListItemText primary="модулів шифрування (доступу до крипто-мережі Мінсоцполітики України)," />
                      </ListItem>

                      <ListItem>
                        <ListItemText primary="пограмне забезпечення «КриптоАвтограф»," />
                      </ListItem>

                      <ListItem>
                        <ListItemText primary="крипто-пошти" />
                      </ListItem>
                    </List>
                    <h5 className="ml-4">
                      Шаблони, які необхідно заповнити та надати ДП «ІОЦ Мінсоцполітики України» для визначення складу
                      ТГ в розрізі:
                    </h5>
                    <List>
                      <ListItem>
                        <ListItemText primary="сільських, селищних та міських рад, старостинських округів," />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="населених пунктів з кодами КОАТУУ та їх приналежність до певних старостинських округів," />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="відділень поштового зв’язку та поштових індексів" />
                      </ListItem>
                      {/* <ListItem>
                        <ListItemText primary="назв вулиць по кожному населеному пункту;" />
                      </ListItem> */}
                    </List>
                    <h5 className="ml-4">
                      Інструкції щодо порядку реєстрації та авторизації у ПК «ІІС «Соціальна громада».
                    </h5>
                    <p>
                      Для користування ПК «ІІС «Соціальна громада» необхідно підключитися до крипто-мережі Міністерства
                      соціальної політики України через налаштування модулів шифрування, які Ви попередньо отримаєте.
                    </p>
                    <p>
                      <b>Для чого налаштовувати ПЗ «Крипто сервер. Модуль шифрування»?</b>
                    </p>
                    <p>
                      Комплекс програмного забезпечення «Криптосервер: Модуль шифрування» призначений для захисту даних,
                      які передаються загальнодоступними або відкритими (Інтернет, орендовані канали, MPLS, тощо)
                      каналами, шляхом шифрування даних із використанням вітчизняних алгоритмів шифрування.
                    </p>
                    <p>
                      ВАЖЛИВО: Вищезазначена крипто-мережа повинна охоплювати усі органи та установи системи соціального
                      захисту населення відповідні уповноважені структурні підрозділи сільських/селищних/міських рад ТГ
                      та старостинських округів для здійснення захищеного обміну інформацією, що містить персональні
                      дані, між усіма суб’єктами, які беруть участь у роботі ПК «ІІС «Соціальна громада» на всій
                      території країни.
                    </p>
                    <p>
                      З навчальними матеріалами щодо ПК «ІІС «Соціальна громада» уповноважені на місцях можуть
                      ознайомитись{' '}
                      <a href="https://www.youtube.com/playlist?list=PLCZVFyAjYB-ky9UkGw3cQWnVyd7I87rSd">тут</a>.
                    </p>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </Grid>
          {/* <Grid item xs={12} sm={12} md={10}>
            <div className={expClasses.root}>
              <Grid container justify="center">
                <Grid item xs={6}>
                  <div className={expClasses.composition}>
                    <div className={`${expClasses.icon} ${expClasses.positionThree}`}>
                      <Steps />
                    </div>
                    <div className={`${expClasses.dot} ${expClasses.positionOne}`}></div>
                    <div className={`${expClasses.dot} ${expClasses.positionTwo}`}></div>
                    <div className={expClasses.horizontalLine}></div>
                  </div>
                </Grid>
              </Grid>

              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={expClasses.headingNormal}>
                    3. <b>Підписати Договір</b> про надання послуг у сфері інформатизації, який надійде на вказану при
                    поданні Заявки офіційну пошту ТГ, разом з модулем(ями) шифрування та з Інструкціями для підключення
                    до ПК «ІІС «Соціальна громада»{' '}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div>
                    <h5 className="ml-4">Інструкції щодо налаштування:</h5>

                    <List>
                      <ListItem>
                        <ListItemText primary="модулів шифрування (доступу до крипто-мережі Мінсоцполітики України)," />
                      </ListItem>

                      <ListItem>
                        <ListItemText primary="пограмне забезпечення «КриптоАвтограф»," />
                      </ListItem>

                      <ListItem>
                        <ListItemText primary="крипто-пошти" />
                      </ListItem>
                    </List>

                    <h5 className="ml-4">
                      Шаблони, які необхідно заповнити та надати ДП «ІОЦ Мінсоцполітики України» для визначення складу
                      ТГ в розрізі:
                    </h5>

                    <List>
                      <ListItem>
                        <ListItemText primary="сільських, селищних та міських рад, старостинських округів," />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="населених пунктів з кодами КОАТУУ та їх приналежність до певних старостинських округів," />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="відділень поштового зв’язку та поштових індексів," />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="назв вулиць по кожному населеному пункту;" />
                      </ListItem>
                    </List>

                    <h5 className="ml-4">
                      Інструкції щодо порядку реєстрації та авторизації у ПК «ІІС «Соціальна громада».
                    </h5>

                    <p>
                      Для користування ПК «ІІС «Соціальна громада» необхідно підключитися до крипто-мережі Міністерства
                      соціальної політики України через налаштування модулів шифрування, які Ви попередньо отримаєте.
                    </p>
                    <p>
                      <b>Для чого налаштовувати ПЗ «Крипто сервер. Модуль шифрування»?</b>
                    </p>
                    <p>
                      Комплекс програмного забезпечення «Криптосервер: Модуль шифрування» призначений для захисту даних,
                      які передаються загальнодоступними або відкритими (Інтернет, орендовані канали, MPLS, тощо)
                      каналами, шляхом шифрування даних із використанням вітчизняних алгоритмів шифрування.
                    </p>
                    <p>
                      ВАЖЛИВО: Вищезазначена крипто-мережа повинна охоплювати усі органи та установи системи соціального
                      захисту населення відповідні уповноважені структурні підрозділи сільських/селищних/міських рад ТГ
                      та старостинських округів для здійснення захищеного обміну інформацією, що містить персональні
                      дані, між усіма суб’єктами, які беруть участь у роботі ПК «ІІС «Соціальна громада» на всій
                      території країни.
                    </p>
                    <p>
                      <i>
                        *Користування програмою ПК «ІІС «Соціальна громада» передбачає оплату за модуль шифрування,
                        технічне обслуговування та надання інформаційно-консультаційних послуг в розмірі від 8 604 грн.
                        на рік – ціна залежить від кількості необхідних модулів шифрування.
                      </i>
                    </p>
                    <p>
                      З навчальними матеріалами щодо ПК «ІІС «Соціальна громада» уповноважені на місцях можуть
                      ознайомитись{' '}
                      <a href="https://www.youtube.com/playlist?list=PLCZVFyAjYB-ky9UkGw3cQWnVyd7I87rSd">тут</a>.
                    </p>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </Grid> */}
        </Grid>
      </div>
    </div>
  );
};

export default withStyles(headersSection)(Connecting);
